import React from 'react';
import './PlanesDePago.css';

const cuentas = [
  {
    banco: 'BCP & YAPE',
    logos: [
      { src: '/111.png', alt: 'BCP' },
    ],
    cuenta: '191-01889958-0-46',
    cci: '00219110188995804659',
    extra: { texto: 'YAPE: 924 648 733' },
  },
  {
    banco: 'INTERBANK',
    logos: [
      { src: '/Interbank_logo.svg.png', alt: 'Interbank' },
    ],
    cuenta: '200-3004460-9-00',
    cci: '00320000300446090033',
    extra: null,
  },
  {
    banco: 'BBVA / PLIN',
    logos: [
      { src: '/BBVA_2019.png', alt: 'BBVA' },
      { src: '/promo-plin.webp', alt: 'Plin' },
    ],
    cuenta: '0011-0319-0200454795',
    cci: '011-319-000200454795-12',
    extra: { texto: 'PLIN ACTIVADO' },
  },
];

const PlanesDePago = () => (
  <section id="planes" className="planes">
    <div className="planes__header">
      <div className="eyebrow">Depósitos Seguros</div>
      <h2 className="section-title">Nuestras Cuentas de Depósito</h2>
    </div>

    <div className="planes__grid">
      {cuentas.map((c) => (
        <div className="plan-card" key={c.banco}>
          <div className="plan-logos-row">
            {c.logos.map((l) => (
              <img key={l.alt} src={l.src} alt={l.alt} className="plan-logo" />
            ))}
          </div>
          <div className="plan-info-box">
            <span className="plan-label">Número de Cuenta</span>
            <span className="plan-number">{c.cuenta}</span>
            <span className="plan-label">CCI</span>
            <span className="plan-number">{c.cci}</span>
            {c.extra && (
              <div className="extra-badge">
                {c.extra.texto}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default PlanesDePago;
